// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Qm4j","detailsBorder":"styles_detailsBorder__QSyRI"};